export enum BestInterests {
	TalkToLovedOnes = "TalkToLovedOnes",
	BeIndependent = "BeIndependent",
	EnjoyFavouriteFood = "EnjoyFavouriteFood",
	LearnAndGrowSkillsAndKnowledge = "LearnAndGrowSkillsAndKnowledge",
	BeDevoutFollowerOfFaith = "BeDevoutFollowerOfFaith",
	Others = "Others",
}

export enum BestInterestsLabel {
	TalkToLovedOnes = "Being able to talk to my loved ones",
	BeIndependent = "Being independent - moving around and going places by myself",
	EnjoyFavouriteFood = "Being able to enjoy my favourite food",
	LearnAndGrowSkillsAndKnowledge = "Being able to learn and grow my skills and knowledge",
	BeDevoutFollowerOfFaith = "Being a devout follower of my faith",
	Others = "Others",
}

// to update to nhs and non-nhs submission later
export enum AcpFormV3Status {
	DRAFT = "DRAFT",
	SUBMITTED = "SUBMITTED",
	EXPIRED = "EXPIRED",
	PENDING_NHS_APPROVAL = "PENDING_NHS_APPROVAL",
	// interim status that may be required later if submission fail on the first try
	PENDING_SUBMISSION_TO_ACP = "PENDING_SUBMISSION_TO_ACP",
	SUBMITTED_TO_ACP_WITH_NHS = "SUBMITTED_TO_ACP_WITH_NHS",
}
export enum AcpNhsStatus {
	PENDING = "PENDING",
	DECLINED = "DECLINED",
	UNDERAGE = "UNDERAGE",
	ACCEPTED = "ACCEPTED",
}

export enum AcpVersion {
	"ACP_V3" = "ACP_V3",
	"ACP_V3_1" = "ACP_V3_1",
	"ACP_PDF" = "ACP_PDF",
	"ACP_PDF_V3_1" = "ACP_PDF_V3_1",
}

export enum AcpTaskStatus {
	PENDING = "PENDING",
	FAILED = "FAILED",
	COMPLETED = "COMPLETED",
}

export enum AcpTaskType {
	// send acp application to ACP IT system after all nhs accepted their responsibility
	SUBMISSION_TO_ACP = "SUBMISSION_TO_ACP",

	// ============== EMAIL ================
	// send email to applicant on creation of acp application without any NHS
	NO_NHS_ACP_EMAIL = "NO_NHS_ACP_EMAIL",
	// send email to nhs on creation of acp application with NHS
	NHS_ASSIGNED_EMAIL = "NHS_ASSIGNED_EMAIL",
	// send email to applicant when nhs rejects their responsibility
	NHS_REJECTED_EMAIL = "NHS_REJECTED_EMAIL",
	// send email to applicant if their nhs is underage
	NHS_UNDERAGE_EMAIL = "NHS_UNDERAGE_EMAIL",
	// send email to nhs after acp application is submitted successfully to ACP IT system
	SUBMISSION_TO_ACP_NHS_EMAIL = "SUBMISSION_TO_ACP_NHS_EMAIL",
	// send email to applicant after acp application is submitted successfully to ACP IT system
	SUBMISSION_TO_ACP_APPLICANT_EMAIL = "SUBMISSION_TO_ACP_APPLICANT_EMAIL",
	// send email to non-affected NHS when applicant remove other NHS
	CHANGE_TO_OTHER_NHS = "CHANGE_TO_OTHER_NHS",
	// send email to affected NHS when applicant remove them.
	REMOVAL_OF_CURRENT_NHS = "REMOVAL_OF_CURRENT_NHS",
	// send email to main applicant after withdrawing ACP
	ACP_WITHDRAWAL_EMAIL_MA = "ACP_WITHDRAWAL_EMAIL_MA",
	// send email to nhs after withdrawing ACP
	ACP_WITHDRAWAL_EMAIL_NHS = "ACP_WITHDRAWAL_EMAIL_NHS",

	// ============== SMS ================
	// send sms to main applicant when nhs rejects invitation
	NHS_REJECTED_SMS_MA = "NHS_REJECTED_SMS_MA",
	// send sms to main applicant when nhs is underage
	NHS_UNDERAGE_SMS_MA = "NHS_UNDERAGE_SMS_MA",
	// send sms to nhs when there is a change to another nhs
	CHANGE_TO_OTHER_NHS_SMS_NHS = "CHANGE_TO_OTHER_NHS_SMS_NHS",
	// send sms to nhs when they are appointed
	NHS_ASSIGNED_SMS_NHS = "NHS_ASSIGNED_SMS_NHS",
	// send sms to nhs when invitation is recalled
	NHS_RECALLED_SMS_NHS = "NHS_RECALLED_SMS_NHS",
	// send sms to main applicant when acp is registered successfully
	ACP_REGISTERED_SUCCESSFULLY_SMS_MA = "ACP_REGISTERED_SUCCESSFULLY_SMS_MA",
}

export enum AcpNotificationStatus {
	DRAFT_CREATED = "DRAFT_CREATED",
	SEVEN_DAYS_AFTER_CREATION = "SEVEN_DAYS_AFTER_CREATION",
	TWO_MONTH_BEFORE_EXPIRY = "TWO_MONTH_BEFORE_EXPIRY",
	SEVEN_DAYS_BEFORE_EXPIRY = "SEVEN_DAYS_BEFORE_EXPIRY",
	EXPIRED = "EXPIRED",
}

export enum AcpNhsNotificationStatus {
	NO_REMINDER = "NO_REMINDER",
	SEVEN_DAYS_AFTER_NOMINATION = "SEVEN_DAYS_AFTER_NOMINATION",
	ONE_MONTH_BEFORE_EXPIRY = "ONE_MONTH_BEFORE_EXPIRY",
}
